import { render, staticRenderFns } from "./NewsItems.vue?vue&type=template&id=60fdb9ea&scoped=true&"
import script from "./NewsItems.vue?vue&type=script&lang=js&"
export * from "./NewsItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fdb9ea",
  null
  
)

export default component.exports